module.exports = __webpack_public_path__ + "img/logo_full.3f809973.svg";